import React from "react";
import axios from "axios";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import { Row, Col, Form, Button, Modal } from "react-bootstrap";
import { css } from "aphrodite";
import { callApi, validateToken } from "../../lib/utils";
import SideDetails from "../GenericComponents/SideDetails";
import SideMenuComponentsHeader from "../GenericComponents/Headers/SideMenuComponentsHeader";
import TextField from "../GenericComponents/TextField";
import SelectField from "../GenericComponents/SelectField";
import DatePickerField from "../GenericComponents/DatePickerField";
import CustomLoader from "../GenericComponents/CustomLoader";
import CustomModal from "../GenericComponents/CustomModal";
import Footer from "../GenericComponents/Footer";
import { AsyncTypeahead } from "react-bootstrap-typeahead";
import styles from "./style";
import ChangePasswordModal from "./ChangePasswordModal";
import ChangeEmailModal from "./ChangeEmailModal";
import VerifyEmailModal from "./VerifyEmailModal";
import "./PatientProfile.css";
import moment from "moment";

class PatientProfile extends React.Component {
  constructor(props) {
    super(props);
    this.typeaheadRefCity = React.createRef();
    this.typeaheadRefState = React.createRef();
    this.typeaheadRefCountry = React.createRef();
    this.inputRef = React.createRef();
    this.state = {
      oldZipcode: "",
      uploadedFileName: null,
      loading: false,
      customModal: false,
      profileUpdateCustomModal: false,
      successMsg: "",
      showChangePassword: false,
      showChangeEmailId: false,
      verificationToken: "",
      newEmailId: "",
      showVerifyEmailModal: false,
      formInputs: {
        profileImage: props.profileImage,
        firstName: props.profileData.patientData.firstName,
        lastName: props.profileData.patientData.lastName,
        phoneNumber: `${props.profileData.patientData.countryCode} ${props.profileData.patientData.mobileNumber}`,
        email: props.profileData.patientData.email,
        dob:
          props.profileData.patientData.dob !== null
            ? moment(props.profileData.patientData.dob).toDate()
            : 0,
        age: "",
        gender: props.profileData.patientData.gender,
        address: props.profileData.patientData.address,
        zipCode: props.profileData.patientData.zipCode,
        city: props.profileData.patientData.city,
        initCities: [],
        cities: [],
        state: props.profileData.patientData.state,
        initStates: [],
        states: [],
        country: props.profileData.patientData.country,
        initCountries: [],
        countries: [],
        medicalCondition: props.profileData.diseaseConditions[0].name,
        medicalConditionType:
          props.profileData.diseaseConditions[0].diseaseConditionType.name,
      },
    };
  }

  componentDidMount() {
    //this.setZipcodeDetails();
    this.calculateAge(this.state.formInputs.dob);
  }

  calculateAge = (dob) => {
    let formInputs = { ...this.state.formInputs };
    if (dob !== 0) {
      var today = new Date();
      var birthDate = dob; // create a date object directly from `dob1` argument
      var age_now = today.getFullYear() - birthDate.getFullYear();
      var m = today.getMonth() - birthDate.getMonth();
      if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
        age_now--;
      }
      formInputs.age = age_now;
    }

    this.setState({ formInputs });
  };

  handleChange = (e) => {
    let fieldName = e.target.name;
    let fieldValue = e.target.value;
    let formInputs = { ...this.state.formInputs };

    formInputs[fieldName] = fieldValue;
    this.setState({
      formInputs,
    });
  };

  setDOB = (fieldName, date) => {
    let formInputs = {
      ...this.state.formInputs,
    };

    formInputs.dob = date;

    this.setState({ formInputs }, () => this.calculateAge(date));
  };

  getBase64 = (file) => {
    return new Promise((resolve) => {
      let baseURL = "";
      // Make new FileReader
      let reader = new FileReader();

      // Convert the file to base64 text
      reader.readAsDataURL(file);

      // on reader load somthing...
      reader.onload = () => {
        // Make a fileInfo Object
        baseURL = reader.result;
        resolve(baseURL);
      };
    });
  };

  handleUpload = () => {
    this.inputRef.current?.click();
  };

  handleDisplayFileDetails = () => {
    let formInputs = {
      ...this.state.formInputs,
    };

    if (this.inputRef.current?.files) {
      let img = this.inputRef.current.files[0];
      this.getBase64(img)
        .then((result) => {
          formInputs.profileImage = result;
          this.setState({
            formInputs,
            uploadedFileName: img,
          });
        })
        .catch((err) => {
          console.log(err);
        });

      // this.setState({
      //   uploadedFileName: img,
      // });
    }
  };

  setZipcodeDetails = (e) => {
    let formInputs = { ...this.state.formInputs };
    validateToken((err) => {
      if (err) {
        window.location = "/logout";
      }
      if (
        formInputs.zipCode !== null &&
        formInputs.zipCode !== "" &&
        formInputs.zipCode !== this.state.oldZipcode
      ) {
        this.setState({
          loading: true,
        });
        callApi(`/api/zipcode/details/${formInputs.zipCode}`, {}, "GET")
          .then((response) => {
            let result = response.data.data.zipCodes;
            if (response.status === 200) {
              if (result !== 0) {
                let cities = [];
                let states = [];
                let countries = [];
                let oldZipcode = formInputs.zipCode;

                result.forEach((val) => {
                  cities.push({
                    id: val.postalLocation,
                    name: val.postalLocation,
                  });
                  states.push({
                    id: val.stateId,
                    name: val.state,
                  });
                  countries.push({
                    id: val.country,
                    name: val.country,
                  });
                });

                this.props.setCities(cities);
                this.props.addZipcodeDetails(result);
                const uniqueStates = [];
                states.forEach((item) => {
                  var findItem = uniqueStates.find((x) => x.id === item.id);
                  if (!findItem) uniqueStates.push(item);
                });
                const uniqueCountries = [];
                countries.forEach((item) => {
                  var findItem = uniqueCountries.find((x) => x.id === item.id);
                  if (!findItem) uniqueCountries.push(item);
                });

                this.props.setStates(uniqueStates);
                this.props.setCountries(uniqueCountries);

                formInputs["country"] =
                  uniqueCountries.length === 1
                    ? uniqueCountries[0].id
                    : this.state.formInputs.country;
                formInputs["city"] =
                  cities.length === 1
                    ? cities[0].id
                    : this.state.formInputs.city;
                formInputs["initCities"] = cities;
                formInputs["cities"] = cities;
                formInputs["state"] =
                  uniqueStates.length === 1
                    ? uniqueStates[0].id
                    : this.state.formInputs.state;
                formInputs["initStates"] = uniqueStates;
                formInputs["states"] = uniqueStates;
                formInputs["initCountries"] = uniqueCountries;
                formInputs["countries"] = uniqueCountries;
                this.setState({
                  loading: false,
                  formInputs,
                  oldZipcode,
                });
              }
            } else {
              this.setState({
                loading: false,
              });
            }
          })
          .catch((err) => {
            console.log("err: ", err);
            this.setState({
              loading: false,
            });
          });

        // this.setState({
        //   formInputs
        // })
      }
    });
  };

  handleCitySearch = (keyword) => {
    const formInputs = this.state.formInputs;
    const cities = this.state.formInputs.initCities.filter((item) => {
      return item.name.toLowerCase().includes(keyword.toLowerCase().trim());
    });
    formInputs.cities = cities;
    this.setState({ formInputs });
  };

  setCity = (data) => {
    if (data?.length) {
      const formInputs = this.state.formInputs;
      formInputs.city = data[0].name;
      this.setState({ formInputs });
    }
  };

  handleCityChange = () => {
    let formInputs = { ...this.state.formInputs };
    formInputs.city = this.typeaheadRefCity.current.inputNode.value;
    this.setState({ formInputs });
  };

  handleStateSearch = (keyword) => {
    const formInputs = this.state.formInputs;
    const states = this.state.formInputs.initStates.filter((item) => {
      return item.name.toLowerCase().includes(keyword.toLowerCase().trim());
    });
    formInputs.states = states;
    this.setState({ formInputs });
  };
  setStateValue = (data) => {
    if (data?.length) {
      const formInputs = this.state.formInputs;
      formInputs.state = data[0].id;
      this.setState({ formInputs });
    }
  };
  handleStateChange = () => {
    let formInputs = { ...this.state.formInputs };
    formInputs.state = this.typeaheadRefState.current.inputNode.value;
    this.setState({ formInputs });
  };
  handleCountrySearch = (keyword) => {
    const formInputs = this.state.formInputs;
    const countries = this.state.formInputs.initCountries.filter((item) => {
      return item.name.toLowerCase().includes(keyword.toLowerCase().trim());
    });
    formInputs.countries = countries;
    this.setState({ formInputs });
  };
  setCountry = (data) => {
    if (data?.length) {
      const formInputs = this.state.formInputs;
      formInputs.country = data[0].id;
      this.setState({ formInputs });
    }
  };
  handleCountryChange = () => {
    let formInputs = { ...this.state.formInputs };
    formInputs.country = this.typeaheadRefCountry.current.inputNode.value;
    this.setState({ formInputs });
  };

  updateProfile = () => {
    let formInputs = { ...this.state.formInputs };
    validateToken((err) => {
      if (err) {
        window.location = "/logout";
      }
      let params = {
        firstName: formInputs.firstName,
        lastName: formInputs.lastName,
        dob: formInputs.dob !== 0 ? moment(formInputs.dob).valueOf() : null,
        gender: formInputs.gender,
        address: formInputs.address,
        city: formInputs.city,
        state: formInputs.state,
        zipCode: formInputs.zipCode,
        country: formInputs.country,
      };
      this.setState({
        loading: true,
      });
      callApi(`/api/web/patient/profile`, params, "PUT")
        .then((response) => {
          this.saveProfileImage();
          //this.props.history.push("/dashboard");
        })
        .catch((err) => {
          console.log("err: ", err);
          this.setState({
            loading: false,
          });
        });
    });
  };

  saveProfileImage = () => {
    let formData = new FormData(); //formdata object
    let url = `/upload/web/patient/profile/image`;
    if (this.state.uploadedFileName !== null) {
      formData.append("profileImage", this.state.uploadedFileName); //append the values with key, value pair

      const config = {
        headers: { "Content-Type": "multipart/form-data" },
      };

      axios
        .patch(url, formData, config)
        .then((response) => {
          //console.log(response);
          this.setState({
            loading: false,
            profileUpdateCustomModal: true,
            successMsg: "Profile updated successfully",
          });
        })
        .catch((error) => {
          console.log(error);
          this.setState({
            loading: false,
          });
        });
    } else {
      this.setState({
        loading: false,
        profileUpdateCustomModal: true,
        successMsg: "Profile updated successfully",
      });
    }
  };

  handleModal = () => {
    this.setState({ profileUpdateCustomModal: !this.state.profileUpdateCustomModal });
  };

  handleSuccessModal = (msg) => {
    this.setState({
      customModal: !this.state.customModal,
      successMsg: msg,
      showChangePassword: false,
      showChangeEmailId: false,
      showVerifyEmailModal: false
    });
  };

  gotoLogin = () => {
    window.location = "/logout";
  }

  handleChangePassword = () => {
    this.setState({ showChangePassword: !this.state.showChangePassword });
  };

  handleChangeEmail = (flag) => {
    let showChangeEmailId = flag;
    this.setState({ showChangeEmailId });
  };

  verifyEmailChange = (token, newEmail) => {
    this.setState({
      showChangeEmailId: false,
      showVerifyEmailModal: !this.state.showVerifyEmailModal,
      verificationToken: token,
      newEmailId: newEmail
    })
  }

  closeVerifyEmailModal = () => {
    this.setState({
      showVerifyEmailModal: !this.state.showVerifyEmailModal,
    })
  }


  // resetPassword = (inputs) => {

  // };

  render() {
    const { profileData, user } = this.props;
    const isReadOnly = user?.roleId === 10;

    return (
      <container>
        <CustomLoader loading={this.state.loading} />
        <Modal
          size={"md"}
          show={this.state.customModal}
          centered={true}
          backdrop="static"
          keyboard={false}
        >
          <Modal.Body>
            <div style={{ paddingBottom: "20px" }}>
              <div style={{ fontWeight: "bold", padding: "10px 0px", fontSize: "20px" }}>{this.state.successMsg}</div>
              <div>{"Please go to login page and enter your credential again to login."}</div>
            </div>
            <Button
              style={{ textAlign: "center", width: "100%", backgroundColor: "white", color: "#3554cf", fontWeight: "500", borderColor: "#aeaeae" }}
              onClick={() => this.gotoLogin()}
            >
              GO TO LOGIN
            </Button>
          </Modal.Body>
        </Modal>

        <CustomModal
          header={""}
          name={""}
          size={"sm"}
          title={this.state.successMsg}
          show={this.state.profileUpdateCustomModal}
          confirmButtons={false}
          action={this.handleModal}
        />
        <ChangePasswordModal
          title={"Change Password"}
          show={this.state.showChangePassword}
          close={this.handleChangePassword}
          handleSuccessModal={this.handleSuccessModal}
        />
        <ChangeEmailModal
          title={"Change Email Address"}
          show={this.state.showChangeEmailId}
          close={this.handleChangeEmail}
          profileData={profileData}
          verifyEmailChange={this.verifyEmailChange}
        />
        <VerifyEmailModal
          title={"Verify Email Address"}
          show={this.state.showVerifyEmailModal}
          close={this.closeVerifyEmailModal}
          token={this.state.verificationToken}
          newEmailId={this.state.newEmailId}
          handleSuccessModal={this.handleSuccessModal}
          profileData={profileData}
        />
        <SideMenuComponentsHeader title={"My Profile"} />
        <div>
          {" "}
          <Row className={css(styles.mainGrid)}>
            {/* <Col xs={12} sm={6} md={3} className={css(styles.sideStyle)}>
              <SideDetails />
            </Col> */}
            <Col xs={12} sm={12} md={12}>
              <div className="patient-profile-content">
                <div className={css(styles.header)}>Profile</div>

                <div className="patient-profile-avatar-row">
                  <div>
                    <img
                      alt="avatar"
                      src={
                        this.state.formInputs.profileImage !== null
                          ? this.state.formInputs.profileImage
                          : "/images/user-flat.png"
                      }
                      className={css(styles.profile)}
                    />
                    {!isReadOnly &&
                      <div style={{ paddingLeft: "10px" }}>
                        <input
                          ref={this.inputRef}
                          onChange={this.handleDisplayFileDetails}
                          className="d-none"
                          type="file"
                        />
                        <button
                          onClick={this.handleUpload}
                          className={css(styles.buttonStyle)}
                        >
                          {"Change"}
                        </button>
                      </div>
                    }
                  </div>
                  {!isReadOnly &&
                    <div>
                      <a
                        onClick={() => this.handleChangeEmail(true)}
                        //className={"primary"}
                        style={{ paddingRight: "15px" }}
                        title="click to change email address"
                      >
                        <img
                          className={css(styles.imageiconsMenu)}
                          alt="changeEmail"
                          src="/images/header/change_email_2.png"
                        />
                      </a>
                      <a
                        onClick={this.handleChangePassword}
                        //className={"primary"}
                        title="click to change password"
                      >
                        <img
                          className={css(styles.imageiconsMenu)}
                          alt="changePassword"
                          src="/images/header/change_password_1.png"
                        />
                      </a>
                    </div>
                  }
                </div>

                <div>
                  <Form autoComplete="off">
                    <Row style={{ marginTop: "2em", lineHeight: "2em" }}>
                      <Col xs={12} sm={6} md={3}>
                        <Form.Group className="mb-3">
                          <Form.Label className={css(styles.labels)}>
                            first name
                          </Form.Label>
                          <div
                            style={{
                              borderBottom: "1px solid #ccc",
                            }}
                          >
                            <TextField
                              type={"text"}
                              placeholder={"Enter Name"}
                              name={"firstName"}
                              value={this.state.formInputs.firstName}
                              action={this.handleChange}
                              className={"patient-input"}
                              isTextOnly={true}
                            //required={true}
                            />
                          </div>
                        </Form.Group>
                      </Col>
                      <Col xs={12} sm={6} md={3}>
                        <Form.Group className="mb-3">
                          <Form.Label className={css(styles.labels)}>
                            last name
                          </Form.Label>
                          <div
                            style={{
                              borderBottom: "1px solid #ccc",
                            }}
                          >
                            <TextField
                              type={"text"}
                              placeholder={"Enter Name"}
                              name={"lastName"}
                              value={this.state.formInputs.lastName}
                              action={this.handleChange}
                              className={"patient-input"}
                              //required={true}
                              isTextOnly={true}
                            />
                          </div>
                        </Form.Group>
                      </Col>
                      <Col xs={12} sm={6} md={2}>
                        <Form.Group className="mb-3">
                          <Form.Label className={css(styles.labels)}>
                            GENDER
                          </Form.Label>
                          <div
                            style={{
                              borderBottom: "1px solid #ccc",
                            }}
                          >
                            <SelectField
                              name={"gender"}
                              options={this.props.gender}
                              value={this.state.formInputs.gender}
                              defaultValue={this.state.formInputs.gender}
                              action={this.handleChange}
                              className={"patient-input"}
                            />
                          </div>
                        </Form.Group>
                      </Col>
                      <Col xs={12} sm={6} md={2}>
                        <Form.Group className="mb-3">
                          <Form.Label
                            className={css(styles.labels)}
                            style={{ marginBottom: "3px" }}
                          >
                            date of birth
                          </Form.Label>
                          <div
                            style={{
                              borderBottom: "1px solid #ccc",
                            }}
                          >
                            <DatePickerField
                              name={"dob"}
                              value={this.state.formInputs.dob}
                              minDate={new Date().setFullYear(
                                new Date().getFullYear() - 100
                              )}
                              maxDate={new Date()}
                              placeholder="Enter date of birth..."
                              action={this.setDOB}
                              selectsStart
                              disabledKeyboardNavigation
                              className={"patient-input form-control"}
                            //required={true}
                            />
                          </div>
                        </Form.Group>
                      </Col>
                      <Col xs={12} sm={6} md={2}>
                        <Form.Group className="mb-3">
                          <Form.Label className={css(styles.labels)}>
                            age
                          </Form.Label>
                          <div
                            style={{
                              borderBottom: "1px solid #ccc",
                            }}
                          >
                            <TextField
                              type={"text"}
                              placeholder={"Age"}
                              name={"age"}
                              value={this.state.formInputs.age}
                              action={this.handleChange}
                              className={"patient-input"}
                              readOnly={true}
                            //required={true}
                            />
                          </div>
                        </Form.Group>
                      </Col>
                      <Col xs={12} sm={6} md={4}>
                        <Form.Group className="mb-3">
                          <Form.Label className={css(styles.labels)}>
                            address
                          </Form.Label>
                          <div
                            style={{
                              borderBottom: "1px solid #ccc",
                            }}
                          >
                            <TextField
                              type={"text"}
                              placeholder={"Enter Address"}
                              name={"address"}
                              value={this.state.formInputs.address}
                              action={this.handleChange}
                              className={"patient-input"}
                              isAlphaNumeric={true}
                            //required={true}
                            />
                          </div>
                        </Form.Group>
                      </Col>
                      <Col xs={12} sm={6} md={2}>
                        <Form.Group className="mb-3">
                          <Form.Label className={css(styles.labels)}>
                            ZIP CODE
                          </Form.Label>
                          <div
                            style={{
                              borderBottom: "1px solid #ccc",
                            }}
                          >
                            <TextField
                              type={"text"}
                              placeholder={"Enter Zipcode"}
                              name={"zipCode"}
                              value={this.state.formInputs.zipCode}
                              action={this.handleChange}
                              onBlurAction={this.setZipcodeDetails}
                              required={true}
                              className={"patient-input"}
                              isNumber={true}
                            />
                          </div>
                        </Form.Group>
                      </Col>
                      <Col xs={12} sm={6} md={2}>
                        <Form.Group className="mb-3">
                          <Form.Label className={css(styles.labels)}>
                            city
                          </Form.Label>
                          <div
                            style={{
                              borderBottom: "1px solid #ccc",
                            }}
                          >
                            <AsyncTypeahead
                              isLoading={false}
                              defaultInputValue={this.state.formInputs.city}
                              filterBy={() => true}
                              id="async-city"
                              labelKey="name"
                              ref={this.typeaheadRefCity}
                              minLength={2}
                              onSearch={this.handleCitySearch}
                              onChange={this.setCity}
                              options={this.state.formInputs.cities}
                              placeholder="Enter City..."
                              inputProps={{ required: true }}
                              onInputChange={this.handleCityChange}
                              onBlur={this.handleCityChange}
                            ></AsyncTypeahead>
                          </div>
                        </Form.Group>
                      </Col>
                      <Col xs={12} sm={6} md={2}>
                        <Form.Group className="mb-3">
                          <Form.Label className={css(styles.labels)}>
                            state
                          </Form.Label>
                          <div
                            style={{
                              borderBottom: "1px solid #ccc",
                            }}
                          >
                            <AsyncTypeahead
                              isLoading={false}
                              defaultInputValue={this.state.formInputs.state}
                              filterBy={() => true}
                              id="async-state"
                              labelKey="name"
                              ref={this.typeaheadRefState}
                              minLength={2}
                              onSearch={this.handleStateSearch}
                              onChange={this.setStateValue}
                              options={this.state.formInputs.states}
                              placeholder="Enter State..."
                              inputProps={{ required: true }}
                              onInputChange={this.handleStateChange}
                              onBlur={this.handleStateChange}
                            ></AsyncTypeahead>
                          </div>
                        </Form.Group>
                      </Col>
                      <Col xs={12} sm={6} md={2}>
                        <Form.Group className="mb-3">
                          <Form.Label className={css(styles.labels)}>
                            country
                          </Form.Label>
                          <div
                            style={{
                              borderBottom: "1px solid #ccc",
                            }}
                          >
                            <AsyncTypeahead
                              isLoading={false}
                              defaultInputValue={this.state.formInputs.country}
                              filterBy={() => true}
                              id="async-country"
                              labelKey="name"
                              ref={this.typeaheadRefCountry}
                              minLength={2}
                              onSearch={this.handleCountrySearch}
                              onChange={this.setCountry}
                              options={this.state.formInputs.countries}
                              placeholder="Enter Country..."
                              inputProps={{ required: true }}
                              onInputChange={this.handleCountryChange}
                              onBlur={this.handleCountryChange}
                            ></AsyncTypeahead>
                          </div>
                        </Form.Group>
                      </Col>
                      <Col xs={12} sm={6} md={3}>
                        <Form.Group className="mb-3">
                          <Form.Label className={css(styles.labels)}>
                            phone number
                          </Form.Label>
                          <div
                            style={{
                              borderBottom: "1px solid #ccc",
                            }}
                          >
                            <TextField
                              type={"text"}
                              placeholder={"Enter Name"}
                              name={"phoneNumber"}
                              value={this.state.formInputs.phoneNumber}
                              action={this.handleChange}
                              //required={true}
                              readOnly={true}
                              className={"patient-input"}
                            />
                          </div>
                        </Form.Group>
                      </Col>
                      <Col xs={12} sm={6} md={3}>
                        <Form.Group className="mb-3">
                          <Form.Label className={css(styles.labels)}>
                            email address
                          </Form.Label>
                          <div
                            style={{
                              borderBottom: "1px solid #ccc",
                            }}
                          >
                            <TextField
                              type={"text"}
                              placeholder={"Enter Name"}
                              name={"email"}
                              value={this.state.formInputs.email}
                              action={this.handleChange}
                              //required={true}
                              readOnly={true}
                              className={"patient-input"}
                            />
                          </div>
                        </Form.Group>
                      </Col>

                      <Col xs={12} sm={6} md={3}>
                        <Form.Group className="mb-3">
                          <Form.Label className={css(styles.labels)}>
                            Monitoring Condition
                          </Form.Label>
                          <div
                            style={{
                              borderBottom: "1px solid #ccc",
                            }}
                          >
                            <TextField
                              type={"text"}
                              placeholder={"Enter Name"}
                              name={"medicalCondition"}
                              value={this.state.formInputs.medicalCondition}
                              action={this.handleChange}
                              //required={true}
                              readOnly={true}
                              className={"patient-input"}
                            />
                          </div>
                        </Form.Group>
                      </Col>
                      {!isReadOnly &&
                        <div style={{ textAlign: "center", marginTop: "3em" }}>
                          <Button
                            variant="primary"
                            type="button"
                            className={css(styles.updateButtonStyles)}
                            onClick={() => this.updateProfile()}
                          >
                            Update
                          </Button>
                        </div>
                      }
                    </Row>
                  </Form>
                </div>
              </div>
            </Col>
          </Row>
          <Footer />
        </div>
      </container >
    );
  }
}

export default connect(
  (store) => {
    return {
      profileData: store.dashboard.profileData,
      profileImage: store.dashboard.profileImage,
      gender: store.profile.gender,
      cities: store.profile.cities,
      states: store.profile.states,
      countries: store.profile.countries,
      zipcodes: store.profile.zipcodes,
      user: store.user
    };
  },
  (dispatch) => {
    return {
      setCities: (cities) => {
        dispatch({
          type: "SET_CITY_LIST",
          payload: { cities },
        });
      },
      setStates: (states) => {
        dispatch({
          type: "SET_STATE_LIST",
          payload: { states },
        });
      },
      setCountries: (countries) => {
        dispatch({
          type: "SET_COUNTRY_LIST",
          payload: { countries },
        });
      },
      addZipcodeDetails: (zipcodes) => {
        dispatch({
          type: "ADD_ZIPCODE_DETAILS",
          payload: { zipcodes },
        });
      },
    };
  }
)(withRouter(PatientProfile));
